import * as React from "react";
const baseClass = "rj-pulse-bet-markets__time-period";
export class TimePeriod extends React.Component {
    renderPeriods() {
        return this.props.periodFrames.map(this.periodFrameDraw, this);
    }
    periodFrameDraw(frame) {
        return (React.createElement("span", { className: `${baseClass}-frame`, key: frame }, frame));
    }
    render() {
        return (React.createElement("div", { className: `${baseClass}` }, this.renderPeriods()));
    }
}
//# sourceMappingURL=TimePeriod.js.map